module.exports = __webpack_public_path__ + "img/person2.39c99308.jpg";